import {useBaseRequest} from "./base.repository";
import {useCallback} from "react";

export function useAssessmentQuestionRepository() {
  const { post, get } = useBaseRequest();

  const importQuestions = useCallback((questions, questionBankName, createNewQuestionBank) => {
    return post({
      body: { data: questions, questionBankName, createNewQuestionBank },
      path: 'quiz-assessment-question/import'
    })
  }, [post]);

  const findById = useCallback((id) => {
    return get({
      path: 'quiz-assessment-question/' + id
    })
  }, [get]);

  return {
    importQuestions,
    findById
  }
}